// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OA_m","col":"styles_col__1Sk7y"};